import React, { useEffect, useState } from "react";
import ProductForm from "../../components/Forms/ProductForm";
import {  AdminAddProductsApi, FetchAllSellers } from "../../ApiCalls/AddProducts";
import SuccessPoP from "../../components/SuccessFullPopUp/SuccessPoP";

const AdminCreateItem = () => {
  const [productData, setProductData] = useState({
    name: "",
    product_code: "",
    description: "",
    actual_price: "",
    category: "",
    subcategory: "",
    stock: "",
    offer_percent: "",
    min_order_quantity: "",
    min_order_quantity_two: "",
    min_order_quantity_three: "",
    min_order_quantity_four: "",
    min_order_quantity_five: "",
    delivery_charge: "",
    vendor: "",
    brand: "",
    currency: "",
    unit: "",
    product_images: [],
  });
  const [sellers, setSellers] = useState([]);
   const SellerFetch = async () => {
      try {
        const response = await FetchAllSellers();
        setSellers(response?.data || []);
        console.log("Sellers:", response.data);
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    };
    useEffect(() => {
      SellerFetch();
    }, []);

  const [popup, setPopup] = useState({
       visible: false,
       success: false,
       button: false,
       message: "",
       subMessage: "",
       showCloseIcon: false,
       Trybutton: false,
     });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setProductData((prevData) => ({
      ...prevData,
      product_images: [...prevData.product_images, ...files],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.keys(productData).forEach((key) => {
      if (key !== "product_images" ) {
        formData.append(key, productData[key]);
      }
    });


    productData.product_images.forEach((image) => {
      formData.append("images", image);
    });

    try {
      await AdminAddProductsApi(formData);
      setPopup({
        visible: true,
        success: true,
        button: false,
        showCloseIcon: true,
        message: "Product Added Successfully!",
        subMessage: "Your product has been added to the catalog.",
      });

      setProductData({
        name: "",
        description: "",
        actual_price: "",
        category: "",
        subcategory: "",
        stock: "",
        offer_percent: "",
        min_order_quantity: "",
        min_order_quantity_two: "",
        min_order_quantity_three: "",
        min_order_quantity_four: "",
        min_order_quantity_five: "",
        delivery_charge: "",
        vendor: "",
        product_code: "",
        brand: "",
        currency: "",
        unit: "",
        product_images: [],
      });

      //   if (refetchProducts) await refetchProducts();
    } catch (error) {
      console.error("Error adding product:", error);
      setPopup({
        visible: true,
        success: false,
        button: false,
        showCloseIcon: true,
        message: "Error Adding Product!",
        subMessage: "There was an issue adding your product. Please try again.",
      });
    }
  };

  const handleRemoveImage = (index) => {
    setProductData((prevData) => ({
      ...prevData,
      product_images: prevData.product_images.filter((_, i) => i !== index),
    }));
  };

  return (
    <div className="h-full w-full space-y-4 ">
     <h2 className="text-2xl font-medium text-green-600 "> Admin Create Item</h2> 
      <div className="h-full w-full">
        <ProductForm
          productData={productData}
          handleChange={handleChange}
          handleImageChange={handleImageChange}
          handleSubmit={handleSubmit}
          sellers={sellers}
          handleRemoveImage={handleRemoveImage}
        />
        {popup.visible && (
          <div className="fixed left-1/2 top-1/2 h-fit w-fit -translate-x-1/2 -translate-y-1/2 transform rounded-lg bg-white shadow-md">
            {/* // <div className="fixed inset-0 flex items-center w-full h-full justify-center  bg-black bg-opacity-50"> */}
            <SuccessPoP
              message={popup.message}
              status={popup.success}
              button={popup.button}
              subMessage={popup.subMessage}
              onClose={() => setPopup({ visible: false, success: false })}
              // redirectPath="/"
              showCloseIcon={popup.showCloseIcon}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminCreateItem;
